import Axios from "axios";
import { API_HOST } from "constants";
import { TOKEN_KEY } from "constants";
import { API_BASE } from "constants";

export const getCurrentUser = (activityId: string, token: string) => {
  return Axios.get(`${API_BASE}/auth/currentUser`, {
    headers: {
      "activity-id": activityId,
      Authorization: `Bearer ${token}`,
    },
  });
};

// 登录接口
export const login = (
  activityId: string,
  data: {
    phone: string;
    code: string;
  }
) => {
  return Axios.post(`${API_BASE}/auth/login`, data, {
    headers: {
      "activity-id": activityId,
    },
  });
};

// 签到接口
export const checkIn = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return Axios.patch(`${API_BASE}/users/checkIn`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// 获取兑换物品的Ticket
export const getExchangeItemTicket = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return Axios.post(`${API_BASE}/users/getExchangeTicket`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// 兑换物品
export const exchangeItem = (sku: string, ticket: string, target?: string) => {
  console.log(`ticket ${ticket}`);
  const token = localStorage.getItem(TOKEN_KEY);
  return Axios.patch(
    `${API_BASE}/users/exchangeItem`,
    {
      sku,
      target,
      ticket,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// 个人兑换记录
export const getUserExchangeRecords = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return Axios.get(`${API_BASE}/users/exchangeRecords`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const shareActivity = (gameId: string) => {
  const token = localStorage.getItem(TOKEN_KEY);
  return Axios.post(`${API_BASE}/users/shareActivity?gameId=${gameId}`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getWeChatJsApiSig = (url: string) => {
  return getJsApiSig(url, "wechat");
};

export const getWeiboJsApiSig = (url: string) => {
  return getJsApiSig(url, "weibo");
};

const getJsApiSig = (url: string, type: "wechat" | "weibo") => {
  return Axios.get(`${API_HOST}/api/jsapi`, {
    params: {
      url,
      type,
    },
  });
};
